// Just adding this code to avoid using querySelectorAll for each slider and to prevent iterating through them every time when snippet added,
// as the code also handles the case where there may be multiple sliders on the page.
// The JS logic is attached to each snippet individually due to task constraints, so we cannot implement this globally.

(function () {
  if (!Splide) return;
  const scriptElement = document.currentScript;
  const currentSectionId = scriptElement?.dataset?.sectionInitiator;
  if (!currentSectionId) return;

  let splide;
  const getSliderAndConfig = (currentSectionId) => {
    const section = document.getElementById(
      `shopify-section-${currentSectionId}`
    );

    const sectionSlider = section.querySelector(".splide");
    if (!sectionSlider) return;

    const sliderConfig = JSON.parse(
      sectionSlider.getAttribute("data-slider-config")
    );
    return { sectionSlider, sliderConfig };
  };
  const initSlider = (sectionSlider, sliderConfig) => {
    splide = new Splide(sectionSlider, sliderConfig);
    splide.mount();
  };

  const initBySectionId = (currentSectionId) => {
    const { sectionSlider, sliderConfig } =
      getSliderAndConfig(currentSectionId);
    if (!sectionSlider || !sliderConfig) return;
    initSlider(sectionSlider, sliderConfig);
  };

  initBySectionId(currentSectionId)

  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", (e) => {
      if(splide) {
        splide.destroy();
        initBySectionId(e.detail.sectionId)
      }
    });
    document.addEventListener("shopify:block:select", (e) => {
      const currentBlock = document.querySelector(`[data-id=${e.detail.blockId}`)
      const currentIndex = currentBlock?.dataset?.index
      if(splide && currentIndex) {
        splide.go(Number(currentIndex))
      }
    })
  }
})();
